import { DwAction, DwActionHandler, DwActionItemRequirement, DwGridEventType, DwActionResult, DwActionState, DwActionType, DwGridActionKeys, DwGridActionResult, DwGridMultiEditConfig, DwGridMultiEditConfigComponent, DwMetaDataGridActionState, DwModalButtonStandardConfigs, DwModalConfig, DwModalService, DwModalSize, ensureArray } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { PerformanceManagementMetaDataItemNames } from '../meta-data/performancemanagement-meta-data.service';
import { EmployeeReviewKickoffModalComponent } from '../components/employee-review-kickoff-modal/employee-review-kickoff-modal.component';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { EmployeeReviewKickoffModalArgs } from '../models/emplyoee-review-kickoff-modal-args.model';
import { EmployeeReviewKickoffModalResult } from '../models/employee-review-kickoff-modal-result.model';


@DwAction({
    keyName: 'reviewKickOff',
    display: 'Kickoff Evals',
    actionType: DwActionType.gridAction,
    isGlobal: false,
    parentItemName: PerformanceManagementMetaDataItemNames.EmployeeReviewSummary,
    allowOnce: true,
    // configComponent: DwGridSetValueActionConfigComponent,
    defaultMenuConfig: {
        useParentDisplay: false,
        menuDisplay: 'Kickoff Evals',
        itemRequirement: DwActionItemRequirement.none,
    },
    defaultButtonConfig: {
        buttonClass: 'btn-sm btn-success mr-1 mt-1',
        buttonText: 'Kickoff Eval',
        iconClass: 'fa fa-user-tag'
    },
    defaultSecurityConfig: {
        requireCanUpdate: true
    },
    configData: {
        refreshFullGrid: true,
        includeAllAttributes: true
    }
})

@DwAction({
    keyName: 'reviewKickOffRow',
    display: 'Kickoff Eval (Row)',
    actionType: DwActionType.gridRowAction,
    isGlobal: false,
    parentItemName: PerformanceManagementMetaDataItemNames.EmployeeReviewSummary,
    allowOnce: true,
    // configComponent: DwGridSetValueActionConfigComponent,
    defaultMenuConfig: {
        useParentDisplay: false,
        menuDisplay: 'Kickoff Evals',
        itemRequirement: DwActionItemRequirement.single,
    },
    defaultButtonConfig: {
        buttonClass: 'btn-sm btn-success mr-1 mt-1',
        buttonText: 'Kickoff Eval',
        iconClass: 'fa fa-user-tag'
    },
    defaultSecurityConfig: {
        requireCanUpdate: true
    },
    configData: {
        refreshFullGrid: true,
        includeAllAttributes: true
    }
})
@DwAction({
    keyName: 'reviewKickOffContext',
    display: 'Kickoff Evals (Context)',
    actionType: DwActionType.gridContextMenuAction,
    isGlobal: false,
    parentItemName: PerformanceManagementMetaDataItemNames.EmployeeReviewSummary,
    allowOnce: true,
    // configComponent: DwGridSetValueActionConfigComponent,
    defaultMenuConfig: {
        useParentDisplay: false,
        menuDisplay: 'Kickoff Evals',
        itemRequirement: DwActionItemRequirement.multiple,
    },
    defaultSecurityConfig: {
        requireCanUpdate: true
    },
    configData: {
        refreshFullGrid: true,
        includeAllAttributes: true
    }
})
@Injectable()
export class EmployeeReviewKickoffActionService implements DwActionHandler {
    constructor(
        private dwModalService: DwModalService,
    ) { }
    
    eventType: DwGridEventType
    handleAction(actionState: DwMetaDataGridActionState<any>): Observable<DwActionResult> {

        this.eventType = actionState.event.eventType;

        let data = ensureArray(actionState.event.eventData);

        if (data.length == 0) {
            // grid actions don't get the data passed, only grid row or context menu actions
            data = ensureArray(actionState.metaDataGridApi.getSelectedRows());
        }

        // if (data.length == 0) {
        //     // Nothing to do in this case
        //     const result = new DwGridActionResult();

        //     actionState.metaDataGridApi.getSelectedRows();

        //     result.success = false;
        //     result.message = `Please select at least one review to get started`;

        //     return of(result);
        // }
        return this.showKickoffModal(data);
    }


    showKickoffModal(data: any[]): Observable<DwActionResult> {
        let modalConfig = new DwModalConfig();

        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;

        modalConfig.buttons[0].buttonText = 'Kickoff Evals';
        modalConfig.allowFullScreen = true;

        const modalOptions: EmployeeReviewKickoffModalArgs = {
            reviewSummaries: data,
            eventType: this.eventType
        }

        modalConfig.data = modalOptions;
        modalConfig.component = EmployeeReviewKickoffModalComponent;
        modalConfig.modalSize = DwModalSize.responsive;
        

        modalConfig.title = `Kickoff Eval Process`;

        window.scroll(0,0);

        return this.dwModalService.showModal(modalConfig)
            .pipe(map(modalResult => {

                const result = new DwGridActionResult();

                result.success = true;

                if (!modalResult.cancelled) {
                    result.refreshData = true;
                    const kickOffModalResult: EmployeeReviewKickoffModalResult = modalResult.data;

                    const updatedCount = kickOffModalResult?.reviewSummaries?.length || 0;

                    const evalText  = updatedCount == 1 ? 'Eval is ' : 'Evals are ';

                    result.message = `${updatedCount} ${evalText} now In Progress!`;
                }
                
                return result;
            }));
    }

}